export const apiToken = (state) => state.account.token

export const companyID = (state) => state.account.company._id

export const hasMinWage = (state) => state.account.company.minimumWage.hasDashboardAccess

export const hasPosterCheck = (state) => state.account.company.posterCheck.pcEnabled

export const hasTipped = (state) => state.account.company.hasTippedEmployees

export const hasClientLogo = (state) => state.account.company.logo

export const userId = (state) => state.account.user.id

export const primaryFormat = (state) => (state.account.company.planogramFormat ? state.account.company.planogramFormat : 'AOO')

export const hasPermission = (state) => (permission) => {
  if (state.account.permissions.indexOf(permission) > -1) {
    return true
  }
  return false
}
